import { styled } from '@mui/material/styles';
import { Table, TableCell, tableCellClasses, TableHead, TablePagination, TableRow, TableSortLabel } from '@mui/material'
import React, { useState } from 'react'

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: "#f0f0f0",
        //color: "#3284C2",
        whiteSpace: "nowrap"
    },
}));


export default function UseTable(tblData, headCells, filterFn,
    totalRecords, pageSize, pageIndex,
    handlePageChange,
    handleRowsPerPage) {

    const pages = [5, 10, 25];
    const [order, setOrder] = useState();
    const [orderBy, setOrderBy] = useState();

    const TblContainer = props => (
        <Table>
            {props.children}
        </Table>
    )

    const handleSortRequest = (cellId) => {
        const isAsc = orderBy === cellId && order === "asc";
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(cellId);
    }

    const TblHeader = props => {
        return (<TableHead>
            <TableRow>
                {headCells.map(item =>
                    <StyledTableCell key={item.id}
                        sortDirection={orderBy === item.id ? orderBy : false}
                    >
                        <TableSortLabel
                            active={orderBy === item.id}
                            direction={orderBy === item.id ? order : 'asc'}
                            onClick={() => handleSortRequest(item.id)}
                        >
                            {item.label}
                        </TableSortLabel>
                    </StyledTableCell>
                )}
            </TableRow>
        </TableHead>)
    }

    const handleChangePage = (event, newPage) => {
        //setPage(newPage);
        handlePageChange(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        //setRowsPerPage(parseInt(event.target.value, 10));
        //setPage(0);
        handleRowsPerPage(parseInt(event.target.value, 10));
    };

    const TblPagination = () => (
        <TablePagination
            component="div"
            page={pageIndex - 1}
            rowsPerPageOptions={pages}
            rowsPerPage={pageSize}
            count={totalRecords}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
        />
    )

    function stableSort(array, comparator) {
        const stabilizedThis = array.map((el, index) => [el, index]);
        stabilizedThis.sort((a, b) => {
            const order = comparator(a[0], b[0]);
            if (order !== 0) {
                return order;
            }
            return a[1] - b[1];
        });
        return stabilizedThis.map((el) => el[0]);
    }

    function descendingComparator(a, b, orderBy) {
        if (b[orderBy] < a[orderBy]) {
            return -1;
        }
        if (b[orderBy] > a[orderBy]) {
            return 1;
        }
        return 0;
    }

    function getComparator(order, orderBy) {
        return order === 'desc'
            ? (a, b) => descendingComparator(a, b, orderBy)
            : (a, b) => -descendingComparator(a, b, orderBy);
    }


    const tblDataAfterPaginationAndSorting = () => {
        return stableSort(filterFn.fn(tblData), getComparator(order, orderBy));
        //.slice(page * rowsPerPage, (page + 1) * rowsPerPage);
    }

    return {
        TblContainer,
        TblHeader,
        TblPagination,
        tblDataAfterPaginationAndSorting
    }
}
